/**
 * 权限
 */
import Vue from 'vue'
import * as common from './common'

Vue.directive('permissions', {
  // 第一次绑定的时候调用
  bind(el /* Dom节点 */, bind /* bind 详细信息 比如value,有很多属性 */) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i]) {
        hasPerm = true
        break
      }
    }
    if (!hasPerm) {
      el.style.display = 'none'
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
  // 节点更新的时候调用
  update(el, bind) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i]) {
        hasPerm = true
        break
      }
    }
    if (!hasPerm) {
      el.style.display = 'none'
      // 没有权限 移除Dom元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
  // 插入时调用
  inserted(el, bind) {},
  // 解绑时调用
  unbind(el, bind) {}
})

Vue.directive('showByRole', {
  // 第一次绑定的时候调用
  bind(el /* Dom节点 */, bind /* bind 详细信息 比如value,有很多属性 */) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i] || permissions[i].indexOf(bind.value) === 0) {
        hasPerm = true
        break
      }
    }
    if (!hasPerm) {
      el.style.display = 'none'
    }
  },
  // 节点更新的时候调用
  update(el, bind) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i] || permissions[i].indexOf(bind.value === 0)) {
        hasPerm = true
        break
      }
    }
    if (!hasPerm) {
      el.style.display = 'none'
    }
  },
  // 插入时调用
  inserted(el, bind) {},
  // 解绑时调用
  unbind(el, bind) {}
})

Vue.directive('disabled', {
  // 第一次绑定的时候调用
  bind(el /* Dom节点 */, bind /* bind 详细信息 比如value,有很多属性 */) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i] || permissions[i].indexOf(bind.value) === 0) {
        hasPerm = true
        break
      }
    }
    console.log(el)
    if (!hasPerm) {
      el.disabled = true
    }
  },
  // 节点更新的时候调用
  update(el, bind) {
    const userInfo = common.session.get('userInfo') || {}
    const permissions = userInfo.permissions || []
    let hasPerm = false
    for (let i = 0; i < permissions.length; i++) {
      if (bind.value === permissions[i] || permissions[i].indexOf(bind.value === 0)) {
        hasPerm = true
        break
      }
    }
    if (!hasPerm) {
      el.disabled = true
    }
  },
  // 插入时调用
  inserted(el, bind) {},
  // 解绑时调用
  unbind(el, bind) {}
})
